export default "__VITE_ASSET__CPjwbaHw__"